export default {
  methods: {
    isObject(object) {
      return object != null
      && object.constructor.name === 'Object';
    },
    objLength(object) {
      let length = 0;
      for (const key in object) {
        if (object.hasOwnProperty(key)) length++;
      }
      return length;
    },
  },
};
